import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../assets/styles/Header.css';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isPORMenuOpen, setIsPORMenuOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu when route changes
  useEffect(() => {
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
    }
  }, [location.pathname]);

  // Change header style on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setIsPORMenuOpen(false);
  };

  const togglePORMenu = () => {
    setIsPORMenuOpen(!isPORMenuOpen);
  };

  // Function to handle navigation link clicks
  const handleNavLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-wrapper">
          <div className="logo">
            <Link to="/" aria-label="Translate Stocks Home" onClick={handleNavLinkClick}>
              <picture>
                {/* WebP version for browsers that support it */}
                <source 
                  srcSet="/images/optimized/translate-stocks-logo-180.webp 180w, 
                          /images/optimized/translate-stocks-logo-120.webp 120w"
                  sizes="(max-width: 768px) 120px, 180px"
                  type="image/webp"
                />
                {/* PNG fallback for browsers that don't support WebP */}
                <source 
                  srcSet="/images/optimized/translate-stocks-logo-180.png 180w, 
                          /images/optimized/translate-stocks-logo-120.png 120w"
                  sizes="(max-width: 768px) 120px, 180px"
                  type="image/png"
                />
                <img 
                  src="/images/translate-stocks-logo.png" 
                  alt="Translate Stocks Logo" 
                  width="180" 
                  height="40"
                  style={{
                    maxWidth: '100%',
                    height: 'auto'
                  }}
                />
              </picture>
            </Link>
          </div>

          <nav className={`main-nav ${isMobileMenuOpen ? 'open' : ''}`}>
            <ul>              
              <li><Link to="/price-on-rails" onClick={handleNavLinkClick}>Price on Rails</Link></li>
              <li><Link to="/pricing" onClick={handleNavLinkClick}>Pricing</Link></li>              
              <li><Link to="/stock-analysis" onClick={handleNavLinkClick}>Stock Analysis</Link></li>
              <li><Link to="/blog" onClick={handleNavLinkClick}>Blog</Link></li>              
              <li><Link to="/contact" onClick={handleNavLinkClick}>Contact</Link></li>
            </ul>
            
            {/* Mobile auth buttons */}
            <div className="mobile-auth-buttons">
              <Link to="https://www.translatestocks.com/login" className="btn btn-outline" onClick={handleNavLinkClick}>Log In</Link>
              <Link to="/pricing" className="btn btn-primary" onClick={handleNavLinkClick}>Sign Up</Link>
            </div>
          </nav>

          <div className="header-actions">
            <Link to="https://www.translatestocks.com/login" className="btn btn-outline" onClick={handleNavLinkClick}>Log In</Link>
            <Link to="/pricing" className="btn btn-primary" onClick={handleNavLinkClick}>Sign Up</Link>
          </div>

          <button 
            className="mobile-menu-toggle" 
            onClick={toggleMobileMenu}
            aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
